<template>
  <div class="progress-con">
    <div
      class="item"
      v-for="item in progress_data"
      :key="item.title"
      :style="{ marginBottom: marginBottom }"
    >
      <div class="item-title">{{ item.title }}</div>
      <el-progress
        :percentage="item.percentage"
        :color="customColors"
        :stroke-width="strokeWidth"
        v-if="!isNaN(parseInt(item.percentage))"
        :format="format"
      ></el-progress>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customColors: {
      type: String,
      default: "#4ea4e1",
    },
    progress_data: {
      type: Array,
      default: () => [],
    },
    strokeWidth: {
      type: Number,
      default: 16,
    },
    marginBottom: {
      type: String,
      default: "40px",
    },
  },
  data() {
    return {};
  },
  methods: {
    format(percentage) {
      return percentage >= 100 ? percentage : `${percentage}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-con {
  width: 100%;
  .item {
    width: 100%;
    display: flex;
    align-content: center;
    justify-content: flex-start;
    margin-bottom: 42px;
    .item-title {
      width: 120px;
      text-align: right;
      color: #fff;
      font-size: 16px;
      margin-right: 10px;
    }
  }
}
.el-progress ::v-deep .el-progress-bar {
  width: 95%;
}
</style>
<style>
.el-progress {
  width: 100%;
}
.el-progress-bar__outer {
  background-color: rgba(27, 87, 157, 0.7) !important;
}
.el-progress__text {
  color: #fff;
}
</style>
